var _path, _path2, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "app-store_2_",
    "data-name": "app-store (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.158,
    height: 75.158,
    viewBox: "0 0 75.158 75.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14668",
    "data-name": "Path 14668",
    d: "M59.745,75.158H15.413A15.431,15.431,0,0,1,0,59.745V15.413A15.431,15.431,0,0,1,15.413,0H59.745A15.431,15.431,0,0,1,75.158,15.413V59.745A15.431,15.431,0,0,1,59.745,75.158Z",
    transform: "translate(0 0)",
    fill: "#00c3ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14669",
    "data-name": "Path 14669",
    d: "M278.166,0H256V75.158h22.166a15.431,15.431,0,0,0,15.413-15.413V15.413A15.431,15.431,0,0,0,278.166,0Z",
    transform: "translate(-218.421 0)",
    fill: "#00aaf0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6743",
    "data-name": "Group 6743",
    transform: "translate(12.551 15.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14670",
    "data-name": "Path 14670",
    d: "M117.85,365.92a3.672,3.672,0,0,1-5.013,1.343h0a3.674,3.674,0,0,1-1.343-5.013l.722-1.25h8.475Z",
    transform: "translate(-107.259 -323.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14671",
    "data-name": "Path 14671",
    d: "M89.17,139.649a3.67,3.67,0,0,1,0-7.34h7.219l9.9-17.15-2.684-4.648a3.674,3.674,0,0,1,1.343-5.013h0a3.674,3.674,0,0,1,5.013,1.343l.565.978.565-.978a3.67,3.67,0,1,1,6.356,3.67l-12.585,21.8H112.8l4.238,7.34Z",
    transform: "translate(-85.5 -105.007)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6744",
    "data-name": "Group 6744",
    transform: "translate(37.579 15.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14672",
    "data-name": "Path 14672",
    d: "M287.21,215.719h-2.982l2.417,4.186a3.67,3.67,0,1,1-6.357,3.67L267.546,201.5l4.237-7.34,8.207,14.215h7.219a3.67,3.67,0,1,1,0,7.34Z",
    transform: "translate(-265.851 -181.077)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14673",
    "data-name": "Path 14673",
    d: "M256,291v7.34h6.512L258.274,291Z",
    transform: "translate(-256 -263.697)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14674",
    "data-name": "Path 14674",
    d: "M263.288,107.726a3.67,3.67,0,0,0-6.723-.885l-.565.978h0V122.5l6.921-11.988A3.646,3.646,0,0,0,263.288,107.726Z",
    transform: "translate(-256 -105.006)",
    fill: "#f2f2f2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppStore);
export default __webpack_public_path__ + "static/media/icon-app-store.37fd63bf5f64cc9c5ba2be6d8ca1f4f5.svg";
export { ForwardRef as ReactComponent };